import { IPromise } from 'angular';

import { RequestHelper } from '../helpers/RequestHelper';
import { ResultHelper } from '../helpers/ResultHelper';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { IGetGroupDetailInfoResult, IGroupInfo } from '../models/IGroupInfo';
import { Module } from '../Module';
import { CreateGroupRequest, ICreateGroupParams } from '../ServerApi/requests/CreateGroupRequest';
import { DeleteGroupsRequest } from '../ServerApi/requests/DeleteGroupsRequest';
import {
  GetGroupDetailsRequest,
  IGetGroupDetailsParams,
} from '../ServerApi/requests/GetGroupDetailsRequest';
import { GetGroupsRequest } from '../ServerApi/requests/GetGroupsRequest';
import { IUpdateGroupNameParams, UpdateGroupNameRequest } from '../ServerApi/requests/UpdateGroupNameRequest';
import { UpdateGroupsMinimumSiteRoleRequest } from '../ServerApi/requests/UpdateGroupsMinimumSiteRoleRequest';
import { IGroup, LocalGroupDomainName } from '../ServerApi/types/IGroup';
import { IResult } from '../ServerApi/types/IResponse';
import { ErrorNotifyingServer } from '../services/ErrorNotifyingServer';
import { FetcherFactory } from '../services/FetcherFactory';
import { ServerService } from '../services/ServerService';
import { Resource } from './Resource';

export class Groups extends Resource<IGroupInfo> {

  public static isActiveDirectory(group: IGroup): boolean {
    return group.domainName && group.domainName !== LocalGroupDomainName;
  }

  public static $inject = ['ErrorNotifyingServer', 'FetcherFactory'];

  private server: ServerService;

  constructor(private ErrorNotifyingServer: ErrorNotifyingServer, FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(GetGroupsRequest, ServerApiMapper.groups));

    this.server = ErrorNotifyingServer.getServerService();
  }

  // Actions

  // create new group
  public createGroup(groupName: string): IPromise<IResult> {
    const params: ICreateGroupParams = {
      name: groupName
    };
    return this.ErrorNotifyingServer.sendRequestAndDelay(new CreateGroupRequest(params));
  }

  // delete groups
  public deleteGroups(ids: string[]): IPromise<IResult> {
    return this.ErrorNotifyingServer.sendRequestsAndDelay(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteGroupsRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  // update group name
  public updateGroupName(groupId: string, name: string): IPromise<IResult> {
    const params: IUpdateGroupNameParams = {
      groupId: groupId,
      name: name
    };
    return this.ErrorNotifyingServer.sendRequestAndDelay(new UpdateGroupNameRequest(params));
  }

  // get group details
  public getGroupDetails(groupId: string): IPromise<IGetGroupDetailInfoResult> {
    const params: IGetGroupDetailsParams = {
      id: groupId
    };
    return this.server.sendRequest(new GetGroupDetailsRequest(params)).then((result) => {
      const groupInfo: IGetGroupDetailInfoResult = {
        ...result,
        contentType: 'group'
      };
      return groupInfo;
    });
  }

  public updateGroupsMinimumSiteRole(groupIds: string[], siteRole: string) {
    return this.ErrorNotifyingServer.sendRequestsAndDelay(
      RequestHelper.buildRequests(groupIds, (idsBlock) => {
        return new UpdateGroupsMinimumSiteRoleRequest({
          groupIds: idsBlock,
          minimumSiteRole: siteRole
        });
      }),
      ResultHelper.combineResults
    );
  }

}

Module.instance().service('Groups', Groups);
